const ford = {
  state: () => ({
    images: {
      sedans: [
        // Models missing images
        // {
        //   modelName: "Taurus",
        //   sideView: require("../../../static/images/carcuts/ford/side-view/Ford-Taurus-2.png"),
        //   angleView: require("../../../static/images/carcuts/ford/angle-view/MISSING.png")
        // },
        // {
        //   modelName: "Fiesta",
        //   sideView: require("../../../static/images/carcuts/ford/side-view/Ford-Fiesta-2.png"),
        //   angleView: require("../../../static/images/carcuts/ford/angle-view/MISSING.png")
        // },
        // {
        //   modelName: "Fusion",
        //   sideView: require("../../../static/images/carcuts/ford/side-view/Ford-Fusion-2.png"),
        //   angleView: require("../../../static/images/carcuts/ford/angle-view/fusion.png"),
        //   trims: ["S", "SE", "SEL", "Titanium", "V6 Sport"]
        // },
        {
          modelName: "Mustang",
          sideView: require("../../../static/images/carcuts/ford/side-view/Ford-Mustang-2.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/25-mustang.png"),
          trims: ["EcoBoost", "EcoBoost Premium", "GT", "GT Premium", "Mach 1", "Mach 1 Premium", "Shelby GT500"]
        },
      ],
      suvs: [
        {
          modelName: "Bronco",
          sideView: require("../../../static/images/carcuts/ford/angle-view/bronco21.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/25-bronco.png"),
          trims: ["Base", "Big Bend", "Black Diamond", "Outer Banks", "Badlands", "Wildtrak"]
        },
        {
          modelName: "Bronco Sport",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-bronco-sport.png"),
          trims: ["S", "SE", "SES", "Titanium"]
        },
        {
          modelName: "Escape",
          sideView: require("../../../static/images/carcuts/ford/angle-view/escape.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-escape.png"),
          trims: ["S", "SE", "SE Sport", "SEL", "Titanium"]
        },
        {
          modelName: "Explorer",
          sideView: require("../../../static/images/carcuts/ford/angle-view/explorer.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/25-explorer.png"),
          trims: ["Explorer", "XLT", "Limited", "ST", "Platinum"]
        },
        // {
        //   modelName: "Edge",
        //   sideView: require("../../../static/images/carcuts/ford/side-view/Ford-Edge-2.png"),
        //   angleView: require("../../../static/images/carcuts/ford/angle-view/edge.png"),
        //   trims: ["SE", "SEL", "ST-Line", "Titanium", "ST"]
        // },
        {
          modelName: "Expedition",
          sideView: require("../../../static/images/carcuts/ford/side-view/Ford-Expedition-2.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-expedition.png"),
          trims: ["XL", "XLT", "Limited", "King Ranch", "Platinum"]
        },
        {
          modelName: "Mustang Mach-E",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-mustang-e.png"),
          trims: ["Select", "Premium", "GT", "Rally"]
        },
      ],
      trucks: [
        {
          modelName: "F-150",
          sideView: require("../../../static/images/carcuts/ford/side-view/Ford-F-150-2.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/25-f150.png"),
          trims: ["XL", "XLT", "Lariat", "King Ranch", "Platinum", "Limited", "Tremor", "Raptor"]
        },
        {
          modelName: "Ranger",
          sideView: require("../../../static/images/carcuts/ford/side-view/Ford-Ranger-2.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/25-ranger.png"),
          trims: ["XL", "XLT", "Lariat"]
        },
        {
          modelName: "Super Duty",
          // sideView: require("../../../static/images/carcuts/ford/side-view/superduty.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-super-duty.png")
        },
        {
          modelName: "F-150 Lightning",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-f-150-lightning.png")
        },
        {
          modelName: "Maverick",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-maverick.png")
        },
        {
          modelName: "Transit Van",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-e-transit.png")
        },
        {
          modelName: "E-Transit Van",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-transit.png")
        }
      ],
      evs: [
        {
          modelName: "Escape Hybrid",
          // sideView: require("../../../static/images/carcuts/ford/angle-view/escape.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-escape.png"),
          // trims: ["S", "SE", "SE Sport", "SEL", "Titanium"]
        },
        {
          modelName: "Mustang Mach-E",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-mustang-e.png"),
          // trims: ["Select", "Premium", "GT", "Rally"]
        },
        {
          modelName: "Explorer Hybrid",
          sideView: require("../../../static/images/carcuts/ford/angle-view/explorer.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-explorer.png"),
          trims: ["Explorer", "XLT", "Limited", "ST", "Platinum"]
        },
        {
          modelName: "F-150 Hybrid",
          sideView: require("../../../static/images/carcuts/ford/side-view/Ford-F-150-2.png"),
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-f-150.png"),
          trims: ["XL", "XLT", "Lariat", "King Ranch", "Platinum", "Limited", "Tremor", "Raptor"]
        },
        {
          modelName: "F-150 Lightning",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-f-150-lightning.png")
        },
        {
          modelName: "Maverick",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2025-ford-maverick.png")
        },
        {
          modelName: "E-Transit Van",
          angleView: require("../../../static/images/carcuts/ford/angle-view/2024-ford-transit.png")
        }
      ],
      lifestyleImages: {
        defaultImage: require("../../../static/images/carcuts/ford/lifestyle/26_bronco.png"),
        sedanImage: require("../../../static/images/carcuts/ford/lifestyle/25_mustang.png"),
        suvImage: require("../../../static/images/carcuts/ford/lifestyle/25_explorer.png"),
        truckImage: require("../../../static/images/carcuts/ford/lifestyle/25_f150.png")
      },
      videoLink: [
        "https://player.vimeo.com/progressive_redirect/playback/1138959351/rendition/1080p/file.mp4?loc=external&signature=7a893bad94e437d2159f988aadc763ca4fc75d884b452be24e690d2a3e9f3062"
      ],
      roundButtons: [
        require("../../../static/images/buttons/round-buttons/ford-New.png"), require("../../../static/images/buttons/round-buttons/ford-Used.png"), require("../../../static/images/buttons/round-buttons/ford-ScheduleService.png"), require("../../../static/images/buttons/round-buttons/ford-Worth.png")
      ],
      browseButtons: [
        require("../../../static/images/buttons/browse-buttons/ford-new.png"), require("../../../static/images/buttons/browse-buttons/ford-used.png"), require("../../../static/images/buttons/browse-buttons/ford-service.png"), require("../../../static/images/buttons/browse-buttons/ford-specials.png")
      ],
      swoopIcons: [
        require("../../../static/images/buttons/swoop-icons/ford01.png"), require("../../../static/images/buttons/swoop-icons/ford03.png"), require("../../../static/images/buttons/swoop-icons/ford02.png")
      ],
      homeBanners: [
        require("../../../static/images/banners/ford/CM-DJ-24-Ford-Established.jpg"), require("../../../static/images/banners/ford/CM-DJ-24-Ford-Lifestyle.jpg"), require("../../../static/images/banners/ford/CM-DJ-24-Ford-Modern.jpg"), require("../../../static/images/banners/ford/CM-DJ-24-Ford-Playful.jpg")
      ],
      stripBanners: [
        require("../../../static/images/banners/ford/Ford-SRS-111921-DealerDraft-Established.jpeg"), require("../../../static/images/banners/ford/Ford-SRS-111921-DealerDraft-Lifestyle.jpeg"), require("../../../static/images/banners/ford/Ford-SRS-111921-DealerDraft-Modern.jpeg"), require("../../../static/images/banners/ford/Ford-SRS-111921-DealerDraft-Playful.jpeg")
      ],
      logoExample: [
        require("../../../static/images/buttons/logos/dd-logo-ford.png"),
        require("../../../static/images/buttons/logos/dd-logo-ford-w.png"),
        require("../../../static/images/buttons/logos/dd-logo-ford-25.png")
      ]
    },
   colors: {
      "--primary-color": "#01095b",
      "--primary-dark": "#01142e",
      "--primary-light": "#fff",
      "--secondary-color": "#066FEF",
      "--secondary-dark": "#000",
      "--secondary-light": "#bfbfbf",
    },
    fonts: {
      "--heading-text": "FordF1-Bold, 'Helvetica Neue', Arial, sans-serif",
      "--subheading-text": "FordF1-Medium, 'Helvetica Neue', Arial, sans-serif",
      "--body-text": "FordF1-Regular, 'Helvetica Neue', Arial, sans-serif",
      "--bold-text": "FordF1-Bold, 'Helvetica Neue', Arial, sans-serif",
      "--large-text": "AmericanGroteskCompressed-Black"
    },
    borderRadius: {
      "--brand-br": "50px"
    }
  })
}


export default ford